import { render, staticRenderFns } from "./emitHairstyleeditor.vue?vue&type=template&id=1a052c1f&scoped=true"
import script from "./emitHairstyleeditor.vue?vue&type=script&lang=js"
export * from "./emitHairstyleeditor.vue?vue&type=script&lang=js"
import style0 from "./emitHairstyleeditor.vue?vue&type=style&index=0&id=1a052c1f&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a052c1f",
  null
  
)

export default component.exports